import { render, staticRenderFns } from "./SettingsDataInputs.vue?vue&type=template&id=e54863f0&scoped=true"
import script from "./SettingsDataInputs.vue?vue&type=script&lang=js"
export * from "./SettingsDataInputs.vue?vue&type=script&lang=js"
import style0 from "./SettingsDataInputs.vue?vue&type=style&index=0&id=e54863f0&prod&scoped=true&lang=css"
import style1 from "./SettingsDataInputs.vue?vue&type=style&index=1&id=e54863f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e54863f0",
  null
  
)

export default component.exports